import React from "react";
import { useLanguage } from "../../context/LanguageContext";

const StatsCard = ({ icon, number, description, color = "yellow" }) => {
  const { t } = useLanguage();

  const getColorClasses = (color) => {
    switch (color) {
      case "blue":
        return {
          icon: "text-info",
          number: "text-info",
        };
      case "yellow":
      default:
        return {
          icon: "text-warning",
          number: "text-warning",
        };
    }
  };

  const colorClasses = getColorClasses(color);

  return (
    <div 
      className="stats-card p-4 text-center shadow" 
      style={{ 
        minWidth: "200px", 
        backgroundColor: "rgba(33, 37, 41, 0.4)",
        borderRadius: "20px",
        border: "1px solid rgba(255, 255, 255, 0.1)"
      }}
    >
      <div className={`stats-icon mb-3 ${colorClasses.icon}`} style={{ fontSize: "1.5rem" }}>
        {icon}
      </div>
      <div className={`stats-number mb-2 ${colorClasses.number}`} style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
        {number}
      </div>
      <div className="stats-description text-light" style={{ fontSize: "0.9rem" }}>
        {description}
      </div>
    </div>
  );
};

export default StatsCard;
